<template>
    <div class="introductionBox">
        <businessBanner tabIndex="2"></businessBanner>
        <!-- 标题与简介 -->
        <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">招标采购</p>
            <p class="mt36 jies">瑞和安惠拥有原工程招标、中央投资、政府采购、国际招标等四项招标采购甲级资质，是中国招标投标协会理事单位，河北省招标投标协会副会长单位，河北省公共资源交易协会副会长单位，被中招协评为AAA级信用企业。业务区域覆盖河北省全域及雄安新区，年代理招标项目3000余项，年累计中标额超500亿元，业务体量及市场占有率常年位于河北省前列。</p>
            <p class="mt20 jies">面向未来，瑞和安惠将坚持以数智化战略为引领，推动招标采购业务从"传统程序服务"向"数智化平台价值服务"跃迁。对内实现业务效率大幅提升，决策周期大幅缩短，资源沉淀高速增长；对外形成"智能招采+品牌赋能+行业标杆"的综合影响力。瑞和安惠致力于将招标采购业务打造为集团全过程咨询体系的数据资源入口与现金流支撑点。</p>
        </div>
        <!-- 服务范围 -->
        <div :class="isMobile?'mobileMWrap':'mainWrap'">
            <div :class="isMobile?'mainM':'main flex-row'">
                <div :class="isMobile?'contM':'flex-text'">
                    <div :class="isMobile?'contTM':'section-title'">服务范围</div>
                    <div class="service-section">
                        <p class="sub-title">咨询产品</p>
                        <ul class="service-list">
                            <li>工程招标：工程、货物、服务</li>
                            <li>政府采购：工程、货物、服务</li>
                            <li>企业采购：工程、货物、服务</li>
                            <li>国际招标：货物</li>
                        </ul>
                        <p class="sub-title">数智化产品</p>
                        <ul class="service-list">
                            <li>SaaS产品(6)、数据产品(6)、模型产品(7)、数字孪生产品(1)</li>
                        </ul>
                    </div>
                </div>
                <img :class="isMobile?'contImgShow':'zhaob-img'" src="@/assets/businessScope/zhaob.png" alt="">
            </div>
        </div>
        <!-- 荣誉奖项 -->
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main flex-row'">
                <div :class="isMobile?'contM':'flex-text'">
                    <div :class="isMobile?'contTM':'section-title'">荣誉奖项</div>
                    <ul class="honor-list">
                        <li>中国招标投标协会理事单位</li>
                        <li>中国招标投标协会"基业长青单位"</li>
                        <li>中国招标投标协会AAA级信用企业</li>
                        <li>河北省招标投标协会副会长单位</li>
                        <li>河北省建设工程招标投标协会常务理事单位</li>
                        <li>河北省公共资源交易协会副会长单位</li>
                        <li>河北省公共资源平台建设贡献奖</li>
                        <li>河北省公共资源行业诚信建设奖</li>
                        <li>河北省公共资源行业经济建设贡献奖</li>
                        <li>首届全国招标采购专业技能大赛河北赛区二等奖</li>
                    </ul>
                </div>
                <img :class="isMobile?'contImgShow':'flex-img'" src="@/assets/businessScope/yjal.png" alt="">
            </div>
        </div>
        <!-- 典型业绩展示 -->
        <TypicalAchievement business-type="招标采购" :show-tabs="false" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
export default {
    name: 'EarlierConsultation',
    components: { businessBanner, TypicalAchievement },
    data() {
        return {}
    },
    mounted() {}
}
</script>

<style scoped>
.introductionBox {
    padding-bottom: 50px;
}
.mainShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 42px;
}
.mainWrap {
    width: 100%;
    margin-top: 42px;
}
.mobileMWrap {
    width: 100%;
    margin-top: 20px;
}
.mobileShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 20px;
}
.main {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 60px;
}
.mainM {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.jies {
    line-height: 32px;
    text-indent: 2em;
    color: #444;
    font-size: 15px;
}
.contM {
    width: 100%;
    color: #666;
    line-height: 30px;
}
.contTM {
    color: #247CD6;
    font-size: 22px;
    margin-top: 20px;
    margin-bottom: 16px;
    font-weight: bold;
}
.contImgShow {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    border-radius: 6px;
}
/* 通用图文横排 */
.flex-row {
    display: flex;
    align-items: center;
    gap: 45px;
}
.flex-text {
    flex: 1;
    min-width: 0;
}
.flex-img {
    width: 580px;
    flex-shrink: 0;
    border-radius: 6px;
}
.zhaob-img {
    width: 750px;
    flex-shrink: 0;
    border-radius: 6px;
}
/* 板块标题 */
.section-title {
    color: #247CD6;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 28px;
    padding-left: 14px;
    border-left: 4px solid #247CD6;
    line-height: 1;
}
/* 服务范围 */
.service-section {
    color: #555;
}
.sub-title {
    font-weight: bold;
    font-size: 16px;
    color: #333;
    margin-top: 16px;
    margin-bottom: 12px;
}
.service-list {
    list-style: none;
    padding-left: 0;
    margin: 0 0 12px 0;
}
.service-list li {
    line-height: 36px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
}
.service-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 16px;
}
/* 荣誉列表 */
.honor-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
    columns: 2;
    column-gap: 20px;
}
.honor-list li {
    line-height: 36px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
    color: #555;
    break-inside: avoid;
}
.honor-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 16px;
}
</style>
